import React, { useEffect, useState } from "react";
import useStyles, {
  aboutDrawerWidth,
  aboutTogglebarWidth,
  chartTogglebarWidth,
  filterContainerHeight,
  chartTitleHeight,
} from "../Styles";
import { toolbarHeight, filterToolbarHeight } from "components/app/Styles";
import { Box, Typography, Grid } from "@material-ui/core";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highChartsTilemap from "highcharts/modules/tilemap";
import addHeatmapModule from "highcharts/modules/heatmap";
import { getWindowSize } from "../utils";
import { useSelector } from "react-redux";
import userActions from "../actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import { alias_entity_id_mapping } from "./polymap_constants";
import {
  positions,
  aliases,
  reverse_aliases,
  calculateLegendLabelsForBuckets,
  createYellowSeries,
  findIndexYellow,
} from "./polymap_constants";
import "rc-tooltip/assets/bootstrap_white.css";
import "../GaugePieChart/gaugePie.css";

addHeatmapModule(Highcharts);
highChartsTilemap(Highcharts);
const inactiveTileOpacity = 0.2;
const activeTileOpacity = 1;
const activeTileShadowWidth = 3;

// const valueLabelFormat = (value) => {
//   const num = value;

//   if (typeof value !== "number") {
//     return value;
//   }
//   return `Year ${num}`;
// };

// const ValueLabelComponent = (props) => {
//   const classes = useStyles();
//   const { children, value } = props;
//   const title = valueLabelFormat(value);
//   const { loggedIn } = useSelector((state) => state.auth);
//   return (
//     <Tooltip
//       placement="top"
//       arrow
//       title={title}
//       open={true}
//       classes={{
//         tooltip: classes.technicalTooltipPopper,
//       }}
//     >
//       {children}
//     </Tooltip>
//     // <RCTooltip
//     //   placement="top"
//     //   overlay={title}
//     //   getTooltipContainer={() => document.querySelector(".MuiSlider-thumb")}
//     //   visible={true}
//     //   overlayClassName="rcTooltip"
//     //   defaultVisible={true}
//     // >
//     //   {children}
//     // </RCTooltip>
//   );
// };
const CurrentCitiesPolygonMap = () => {
  const classes = useStyles();
  const { isMobile } = useGetViewPortDimensions();
  const [windowSize, setWindowSize] = React.useState(getWindowSize());
  const {
    toggle_about,
    per_person_entitlement_difference,
    entitlements_by_year,
    entitlement_year,
    cities,
    scenario_selected,
  } = useSelector((state) => state.technical_view);
  const {
    setSelectedCity,
    loadEntityEntitlements,
    loadCityMetrics,
    loadCityWaterSources,
    setIsTribe,
    setIsWesternEntity,
    loadPerPersonEntitlementDifference,
    loadEntitlementsByYear,
    // setEntitlementYear,
  } = userActions();
  const [options, setOptions] = useState(null);
  const [seriesInfo, setSeriesInfo] = useState([]);
  const [legendLabel, setlegendLabel] = useState([]);
  const defaultSliderYear = 2024;
  // const [selectedYear, setSelectedYear] = useState(defaultSliderYear);

  const toggledPolyMapStyle = {
    width: `calc(100vw - ${aboutTogglebarWidth}px - ${chartTogglebarWidth}px)`,
  };  

  /* 
  On any mouseover action (select/hover) on a honeycomb tile, 
  the right side charts and about section information are automatically updated
  */
  const displayDetailsOnTileSelect = (entity_name) => {
    /*
    We need to find cityID in order to load city metrics by calling backend APIs
    We first find the full city name (if any) from the colloquial name from reverse_alias map
    and then find the corresponsing cityID from the cities map
    */
    var aliased_city_name =  reverse_aliases.hasOwnProperty(entity_name)
                ? reverse_aliases[entity_name]
                : entity_name;
    var cityFound = cities.find((item) => item.label === (aliased_city_name));
    // added a condition here because the cityFound variable returns undefined at times causing the page to break
    if(cityFound) {
      var cityIdx = cityFound["value"];
      loadCityMetrics(cityIdx);
      setSelectedCity(cityFound);
      loadEntityEntitlements(cityIdx, scenario_selected.value);
      loadCityWaterSources(cityIdx);
      setIsTribe(false);
      setIsWesternEntity(false);
    }
  }

  const loadEntitlements = () => {
    loadEntitlementsByYear(entitlement_year, scenario_selected.value);
  }

  useEffect(loadEntitlements, [entitlement_year]);

  const componentUnmountHook = () => {
    return () => {
      loadEntitlementsByYear(defaultSliderYear, scenario_selected.value);
    };
  }

  useEffect(componentUnmountHook, []);

  const handleResize = () => {
    loadPerPersonEntitlementDifference(scenario_selected.value);
    // setEntitlementYear(defaultSliderYear); We don't need this because the values are getting reset for other tabs.
    loadEntitlementsByYear(defaultSliderYear, scenario_selected.value);
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }
  useEffect(handleResize, []);

  // update the legend labels when slider change or when we get the info for the entitlements
  useEffect(() => {
    if (entitlements_by_year) {
      const legend = calculateLegendLabelsForBuckets(
        entitlements_by_year
      );
      setlegendLabel(legend);
    }
  }, [entitlements_by_year]);


  const accessWaterHook = () => {
    const width = isMobile
    ? windowSize.innerWidth
    : windowSize.innerWidth -
      (toggle_about ? aboutDrawerWidth : aboutTogglebarWidth) -
      chartTogglebarWidth;
  const height = isMobile
    ? windowSize.innerHeight -
      toolbarHeight -
      filterToolbarHeight -
      chartTitleHeight -
      aboutTogglebarWidth
    : windowSize.innerHeight -
      toolbarHeight -
      chartTitleHeight -
      filterContainerHeight -
      80;
  const dim = isMobile ? Math.min(width, height) - 30 : width / 2 +  + 108;
  const optionsTemp = {
    chart: {
      type: "tilemap",
      width: dim - (isMobile ? 10 : -100),
      height: dim - (isMobile ? 40 : 35),
      plotBackgroundColor: "transparent",
      backgroundColor: "transparent",
      animation: false
    },
    title: {
      text: "",
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    legend: {
      title: {
        text: isMobile
          ? "<p>Access of Water</p><p>per Person</p>"
          : "<p>Access of Water</p><p>per Person</p>",

        style: {
          fontStyle: "normal",
          fontSize: "9px",
        },
      },
      itemStyle: {
        color: "#333333",
        fontSize: "12px",
        fontWeight: "normal",
        fontFamily: "Arial",
      },
      labelFormatter: function () {
        return this.name;
      },
      //   align: "center",
      backgroundColor: "#FFFFFF",
      borderColor: "#E0E0E0",
      borderWidth: 1,
      borderRadius: 15,
      //   width: "25%",
      //   padding: 10,
      itemMarginTop: 5,
      itemMarginBottom: 5,
      shadow: {
        offsetX: -1,
        offsetY: 3,
        color: "#00000029",
        width: 4,
      },
      align: "right",
      verticalAlign: "bottom",
      layout: "vertical",
      x: -100,
      y: -10,
      symbolRadius: 0,
      reversed: true,
      enabled: false,
    },
    tooltip: {
      enabled: false,
      outside: true,
      padding: 16,
      backgroundColor: "#FFF",
      borderRadius: 8,
      useHTML: true,
      style: {
        color: "#000",
        fontFamily: "'Arial', sans-serif",
        lineHeight: "0.5em",
      },
      formatter() {
        const name = this.point.real_name;
        let tooltip = "";
        if (alias_entity_id_mapping.hasOwnProperty(name)) {
          var entity_id = alias_entity_id_mapping[name];
          tooltip += "<p style='line-height:12px'><b>" + name + "</b></p>";
          tooltip += "<p>Year: <strong>" + entitlement_year + "</strong></p>";
          tooltip +=
            "<p>Colorado River access: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(
                  entitlements_by_year[entity_id].total_co_access
                ).toLocaleString("en-US")
              : 0) +
            " ac-ft</strong></p>";
          tooltip +=
            "<p>P3: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(entitlements_by_year[entity_id].p3).toLocaleString(
                  "en-US"
                )
              : 0) +
            " ac-ft</strong></p>";
          tooltip +=
            "<p>Indian: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(
                  entitlements_by_year[entity_id].indian
                ).toLocaleString("en-US")
              : 0) +
            " ac-ft</strong></p>";
          tooltip +=
            "<p>M&I: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(entitlements_by_year[entity_id].mi).toLocaleString(
                  "en-US"
                )
              : 0) +
            " ac-ft</strong></p>";
          tooltip +=
            "<p>NIA A: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(
                  entitlements_by_year[entity_id].nia_a
                ).toLocaleString("en-US")
              : 0) +
            " ac-ft</strong></p>";
          tooltip +=
            "<p>NIA B: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(
                  entitlements_by_year[entity_id].nia_b
                ).toLocaleString("en-US")
              : 0) +
            " ac-ft</strong></p>";
          tooltip +=
            "<p>DCP NIA: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(
                  entitlements_by_year[entity_id].dcp_nia
                ).toLocaleString("en-US")
              : 0) +
            " ac-ft</strong></p>";
          tooltip +=
            "<p>Leases & Exchanges: <strong>" +
            (entitlements_by_year[entity_id]
              ? Math.round(
                  entitlements_by_year[entity_id].leases_exchanges
                ).toLocaleString("en-US")
              : 0) +
            " ac-ft</strong></p>";
        }
        return tooltip;
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        width: 200,
        lineHeight: 200,
        animation: false,
        pointPadding: 2,
        dataLabels: {
          enabled: true,
          color: "#000000",
          format: "{point.name}",
        },
        states: {
          hover: {
            halo: false,
            enabled: false,
          },
        },
        point: {
          events: {
              mouseOver: function () {
                  var seriesData = this.series.data;
                  //looping through all the tiles in the hovered series
                  for (var i=0; i < seriesData.length; i++) {
                    // if a tile specifically is not hovered over, make it look inactive
                    if (i!==this.index) {
                      this.series.data[i].update({opacity: inactiveTileOpacity});
                      Highcharts.each(this.series.data[i].graphic.shadows, function(p) {
                        p.remove();
                      })
                    } 
              }          
              },
              mouseOut: function () {
                var seriesData = this.series.data;
                for (var i=0; i < seriesData.length; i++) {
                  // if a tile specifically was not hovered over, restore it's original active styling
                  if (i!==this.index) {
                    this.series.data[i].update({opacity: activeTileOpacity});
                    this.series.data[i].graphic.shadow({
                      width: activeTileShadowWidth,
                      opacity: activeTileOpacity
                    })
                  }
                    
              }

              },
              click: function () {
                displayDetailsOnTileSelect(this.name);
              }
          }
      },
        shadow: true,
      },
    },
    series: [],
  };

  let series = createYellowSeries(legendLabel);
  setSeriesInfo(series);

  if (
    Object.keys(entitlements_by_year).length &&
    legendLabel.length
  ) {
    for (const [entity_id, entity_entitlements] of Object.entries(entitlements_by_year)) {
        let entity_name;
      // get city name from index
      for (const [alias_key, alias_value] of Object.entries(alias_entity_id_mapping)) {
        if (alias_value === parseInt(entity_id)) {
          entity_name = alias_key;
        }

      }
      if (entity_name && positions.hasOwnProperty(entity_name)) {
        const idx = findIndexYellow(entity_entitlements.total_co_access, entity_name, legendLabel);
        if (typeof idx == "number") {
          series[idx].data.push({
            x: positions[entity_name][0],
            y: positions[entity_name][1],
            name: aliases.hasOwnProperty(entity_name)
              ? aliases[entity_name]
              : entity_name,
            real_name: entity_name,
          });
        }
      }
    };
  }
  optionsTemp.series = series;
  setOptions(optionsTemp);
  }
  useEffect(accessWaterHook, [
    windowSize,
    per_person_entitlement_difference,
    legendLabel,
    entitlements_by_year,
    isMobile,
    toggle_about
  ]);

  return (    
    <>
      <Box className={classes.polymapContainer} style={toggle_about || isMobile ? null : toggledPolyMapStyle}>
        <Grid
          className={classes.highchart}
          style={!isMobile ? { marginTop: 150 } : null}
        >
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Grid>
      </Box>
      <Grid className={classes.chartLegendContainer} style={{marginBottom: 40, marginRight: 16}}>
        <Grid className={classes.chartLegend}>
          <Typography className={classes.polygonLegendTitle}>
            Access of Water <br/> per Person <br /> (ac-ft/person)
          </Typography>
          <Box className={classes.legendItems}>
          {seriesInfo.length &&
                seriesInfo
                  .map((series, idx) => {
                    return (
                      <Grid className={classes.legendItem} key={idx}>
                        <Box
                          classes={{ root: classes.legendItemColor }}
                          style={{ backgroundColor: series.color }}
                        />
                        <Typography className={classes.polygonLegendItemText}>
                          {series.bucketRange}
                        </Typography>
                      </Grid>
                    );
                  })
          }
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default CurrentCitiesPolygonMap;
